import React from 'react';

import { Badge } from './styles';

const conditionColors = {
  Nuevo: '#5FBD74',
  'Como nuevo': '#17A2B8',
  Bueno: '#FFC107',
  Aceptable: '#FAA01E',
};

export default function ConditionBadge({ condition }) {
  const color = conditionColors[condition] || '#999';

  return <Badge $color={color}>{condition}</Badge>;
}
